export default {"src":"/_next/static/media/5-travel-leisure-logo.4d24439e.svg","height":20,"width":86};